import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import { push } from 'redux-little-router'

import VehicleChip from 'components/Chip/VehicleChip'
import Icon from 'discada/dist/Icon'
import FlipChip from './FlipChip'

import { addToPageState } from 'actions/pageStateActions'
import { INTENTS, INTENTS_LABELS } from 'reducers/quoteReducers'
import {
  getInventoryChipProps,
  isShowingVehicle,
} from 'selectors/inventorySelectors'

import './InventoryChip.scss'

export function QuoteBadges({ quotes }) {
  let quoteGroups = Object.keys(quotes).reduce((ret, k) => {
    let q = quotes[k]
    return { ...ret, [q.intent]: (ret[q.intent] || 0) + 1 }
  }, {})

  return (
    <div className="quote-badges">
      {Object.keys(INTENTS)
        .map(k => {
          let qg = quoteGroups[k]

          if (!qg) return null

          return (
            <span className="quote-badge" key={k}>
              <span className={c('has-quotes', `has-quotes-${k}`)}>
                <strong>{qg}</strong>
              </span>
              {INTENTS_LABELS[k] || k}
            </span>
          )
        })
        .filter(x => x)}
    </div>
  )
}

export function InventoryChip(props) {
  return (
    <FlipChip
      {...props}
      className={c('inventory-chip', props.className)}
      front={({ side }) => (
        <VehicleChip
          {...props}
          hasFlip={false}
          side={side}
          xcontrol={
            <span>
              <Icon size="small" icon="filter" />
            </span>
          }
        />
      )}
    />
  )
}

function mapStateToProps() {
  let getProps = getInventoryChipProps()

  return (state, op) => {
    let props = getProps(state, op),
      { vehicle = {} } = props

    return {
      ...props,
      isv: isShowingVehicle(state),
      priceToShow: vehicle.msrp || vehicle.sellingPrice,
      priceLabel: vehicle.msrp ? 'MSRP' : 'Price',
    }
  }
}

export default connect(
  mapStateToProps,
  { addToPageState, push },
)(InventoryChip)
